import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useQuery } from '@office-start/data-fetching';
import { OfficeWorkload, } from '@office-start/officehome-types';
import { useUserStorageOptions } from '@office-start/user-storage-service';
import { useWebStorageGetUserItem } from '@office-start/web-storage-utility';
import { useMemo } from 'react';
import { HARMONY_THEME_USER_STORAGE_KEY } from '../model/harmonyThemeUserStorage';
import { executeWebStorageGetUserItem } from '../operations/executeGetUserStorageItem';
import { getUserStoragQueryKey } from '../util/getUserStorageQueryKey';
export var useGetHarmonyThemeUserStorage = function (storageKey, officeComponentContext) {
    var userStorageOptions = useUserStorageOptions();
    var queryKey = getUserStoragQueryKey(storageKey);
    return useQuery(queryKey, function () {
        return executeWebStorageGetUserItem({
            storageKey: storageKey,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            userStorageOptions: userStorageOptions,
        });
    }, {
        cacheTime: Infinity,
        staleTime: Infinity,
        enabled: !!officeComponentContext &&
            !!userStorageOptions &&
            officeComponentContext.workload !== OfficeWorkload.Hwa,
    });
};
export var useGetHarmonyTheme = function () {
    var officeComponentContext = useOfficeComponentContext().data;
    var themeDataWeb = useGetHarmonyThemeUserStorage(HARMONY_THEME_USER_STORAGE_KEY, officeComponentContext).data;
    var themeDataDesktop = useWebStorageGetUserItem(HARMONY_THEME_USER_STORAGE_KEY).data;
    // In desktop app return local storage, otherwise, return remote storage
    return useMemo(function () {
        if ((officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload) === OfficeWorkload.Hwa) {
            return {
                result: themeDataDesktop,
                fromPersistence: themeDataDesktop !== undefined,
            };
        }
        return themeDataWeb;
    }, [officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload, themeDataDesktop, themeDataWeb]);
};
//# sourceMappingURL=useGetHarmonyTheme.js.map